import {login, logout, getInfo, getMenus} from '@/api/user'
import {getToken, setToken, removeToken} from '@/utils/auth'
import router, {resetRouter} from '@/router'

const state = {
  token: getToken(),
  nickName: '',
  loginName: '',
  adminId: '',
  ipId: '',
  ipStatus: '',
  roleId: [],
  menus: [],
  alreayGeneraterMenus: false
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NICKNAME: (state, nickName) => {
    state.nickName = nickName;
  },
  SET_LOGINNAME: (state, loginName) => {
    state.loginName = loginName;
  },
  SET_ADMINID: (state, adminId) => {
    state.adminId = adminId;
  },
  SET_MENUS: (state, menus) => {
    state.menus = menus;
  },
  SET_IPID: (state, ipId) => {
    state.ipId = ipId;
  },
  SET_IPSTATUS: (state, ipStatus) => {
    state.ipStatus = ipStatus;
  },
  SET_ROLEID: (state, roleId) => {
    state.roleId = roleId;
  }
};

const actions = {
  // user login
  login({commit}, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        const {data} = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({commit, state}) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const {data} = response
        if (!data) {
          reject(new Error('验证失败请重新登录'))
        }
        const {
          nickname,
          login_name,
          id,
          ip_id,
          ip_status,
          role_id
        } = data.admin_info;

        commit('SET_NICKNAME', nickname)
        commit('SET_LOGINNAME', login_name)
        commit('SET_ADMINID', id)
        commit('SET_IPID', ip_id)
        commit('SET_IPSTATUS', ip_status)
        commit('SET_ROLEID', role_id);
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({commit, state}) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        removeToken()
        resetRouter()
        this.dispatch('permission/updateMenusStatus', false);
        router.replace('/login');
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({commit}) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  },

  // Dynamically modify permissions
  changeRoles({commit, dispatch}, role) {
    return new Promise(async resolve => {
      const token = role + '-token'

      commit('SET_TOKEN', token)
      setToken(token)

      const {roles} = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, {root: true})

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      resolve()
    })
  },

  // 获取菜单
  getMenus({commit}) {
    return new Promise((resolve, reject) => {
      getMenus().then(res => {
        if (!res.data) {
          return reject(new Error('获取菜单失败'));
        }
        commit('SET_MENUS', res.data);
        return resolve(res.data)
      })
          .catch(error => {
            reject(error)
          })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js